var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"min":_vm.min,"max":_vm.max,"type":"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }